import angular from "angular";

angular
    .module('app')
    .component('paymentInfo', {
        template: require('./payment-info.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.sale = $ctrl.resolve.sale;
    };

}
